import { render } from "./login-page.vue?vue&type=template&id=5c8affea&scoped=true"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"

import "./login-page.vue?vue&type=style&index=0&id=5c8affea&scoped=true&lang=css"
import "./login-page.vue?vue&type=style&index=1&id=5c8affea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8affea"]])

export default __exports__